import classNames from 'classnames';
import { useField } from 'formik';
import React, { forwardRef } from 'react';

const Checkbox = forwardRef(
  ({ id, label, inputClassName, labelClassName, ...props }, ref) => {
    const [field] = useField({ ...props, type: 'checkbox' });

    return (
      <div className="flex items-center">
        <input
          className={classNames('mr-1', inputClassName)}
          id={id}
          type="checkbox"
          ref={ref}
          {...props}
          {...field}
        />
        <label className={classNames('text-sm', labelClassName)} htmlFor={id}>
          {label}
        </label>
      </div>
    );
  }
);

export default Checkbox;
